import { lazy, StrictMode, Suspense, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "./design-system/base.css";

const AuthPage = lazy(() =>
  import("./features/auth/AuthPage.js").then((module) => ({ default: module.AuthPage })),
);
const Workspace = lazy(() =>
  import("./features/workspace/Workspace.js").then((module) => ({ default: module.Workspace })),
);
const PublishedDashboard = lazy(() =>
  import("./features/publications/PublicationPages.js").then((module) => ({
    default: module.PublishedDashboard,
  })),
);
const PaymentReturnPage = lazy(() =>
  import("./features/billing/BillingPages.js").then((module) => ({
    default: module.PaymentReturnPage,
  })),
);

const root = document.querySelector<HTMLElement>("#root");
if (!root) throw new Error("ROOT_ELEMENT_MISSING");
function App() {
  const [route, setRoute] = useState(window.location.hash || "#/login");
  useEffect(() => {
    const update = () => setRoute(window.location.hash || "#/login");
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);
  return (
    <Suspense fallback={<main className="route-loading">正在安全加载工作区…</main>}>
      {route === "#/payment-return" ? (
        <PaymentReturnPage />
      ) : route === "#/published" ? (
        <PublishedDashboard />
      ) : route === "#/login" ? (
        <AuthPage initialMode="login" />
      ) : route === "#/register" ? (
        <AuthPage initialMode="register" />
      ) : (
        <Workspace />
      )}
    </Suspense>
  );
}
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
